/**
 * Junta a aparencia do menu de duas fontes, durante a migracao:
 *
 *   1. os modulos em `resources/modules/<nome>/routes.js`, que declaram a
 *      propria entrada `nav` ao lado das rotas;
 *   2. o `legacyNavConfig`, com o que ainda nao foi migrado.
 *
 * Modulo vence legado, para que migrar um modulo seja apagar a linha antiga.
 *
 * O `import.meta.glob` e do Vite -- por isso a conversao mora em
 * navFromModules.js, que roda em teste sem bundler.
 */
import { legacyNavConfig } from './legacyNavConfig.js';
import { navDosModulos, navsDosModulos, modulosDeclarados } from './navFromModules.js';

const modulos = import.meta.glob('@/modules/*/routes.js', { eager: true });

export const navConfig = { ...legacyNavConfig, ...navDosModulos(modulos) };

/** Declaracoes cruas, consumidas pelo montarMenu(). */
export const navsDeclarados = navsDosModulos(modulos);

/** Usado pelo menu de reserva -- ver modulosDeclarados(). */
export const navDeReserva = modulosDeclarados(modulos);
